import { isValidPhoneNumber, parsePhoneNumber, findPhoneNumbersInText  } from 'libphonenumber-js';

export const usePhoneValidation = () => {
  const validate = (phone) => {
    return isValidPhoneNumber(phone);
  };

  const format = (phone) => {
    try {
      const parsed = parsePhoneNumber(phone);
      return parsed ? parsed.formatInternational() : phone;
    } catch {
      return phone;
    }
  };

  const findDetail = (text) => {
    return findPhoneNumbersInText(text);
  }

  return {
    validate,
    format,
    findDetail
  };
};
